import GenericService from './GenericService';
import { httpService } from './HttpService';
import { Decimo } from '@/model/Decimo';


export class DecimoService extends GenericService<Decimo>{
    constructor(){
        super("Decimo")
    }

    sacar(idSorteo: number, filtrar: boolean): Promise<Decimo> {
        return httpService.get(this.entity+"/sacar/"+idSorteo+"?filtrar="+filtrar);
    }

    sacados(idSorteo: number, queryString: string): Promise<Decimo> {
        return httpService.get(this.entity+"/sacados/"+idSorteo+queryString);
    }

    sacadoByNumero(idSorteo: number, numero: string): Promise<Decimo> {
        return httpService.get(this.entity+"/sacado/"+idSorteo+"/"+numero);
    }

    bySorteo(idSorteo: number, queryString: string): Promise<Decimo> {
        return httpService.get(this.entity+"/sorteo/"+idSorteo+queryString);
    }

    sacarManualmente(idSorteo: number, numero: string): Promise<boolean> {
        return httpService.get(this.entity+"/sacar-manual/"+idSorteo+"/"+numero);
    }

    // disponibles(idSorteo: number, filtrar: boolean, skip: number, top: number): Promise<Decimo> {
    //     return httpService.get(this.entity+"/disponibles/"+idSorteo+"?filtrar="+filtrar+"&$skip="+skip+"&$top="+top);
    // }

    disponibles(idSorteo: number, filtrar: boolean): Promise<Array<Decimo>> {
        return httpService.get(this.entity+"/disponibles/"+idSorteo+"?filtrar="+filtrar);
    }

    import(idSorteo: number, file: any): Promise<Decimo> {
        return httpService.post(this.entity+"/import/"+idSorteo, file);
    }
}